<script>
import GenericCrud from "@forms/GenericCrud.vue";
import api from "@services/api";
import Select2 from "v-select2-component";
// import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: { Select2 },

  extends: GenericCrud,
  props: {
    table: {
      type: String,
      default: "DePara"
    }
  },
  data: () => ({
    categoriaList: [],
    categoriaSelectList: [],
    categoriavSelectList: [],
    deParaList: []
  }),
  methods: {
    getCategoriaSelectList() {
      api
        .get(`crud/CategoriaDePara`, {
          params: {
            sortBy: "descricao",
            sortOrder: "ASC"
          }
        })
        .then(response => {
          this.categoriaList = response.data["data"];
          this.categoriaList.forEach(e => {
            this.categoriaSelectList.push({ id: e.id, text: e.descricao });
            this.categoriavSelectList.push({ code: e.id, label: e.descricao });
          });
        });
    },
    save() {
      if (!this.item.categoriaDeParaId) {
        alert("Selecione uma categoria");
        return;
      }

      if (
        this.deParaList.filter(x => x.deStr == "" || x.paraStr == "").length > 0
      ) {
        alert("Preencha todos os registros.");
        return;
      }

      var model = {
        novaCategoriaDePara: null,
        categoriaDeParaId: this.item.categoriaDeParaId,
        deParaLista: this.deParaList
      };

      if (
        this.categoriaSelectList.filter(
          x => x.id == this.item.categoriaDeParaId
        ).length == 0
      ) {
        model.novaCategoriaDePara = this.item.categoriaDeParaId;
        model.categoriaDeParaId = 0;
      }

      // insert

      api.post(`crud/${this.table}/BulkInsert`, model).then(response => {
        if (response.data["status"].toLowerCase() == "success") {
          this.hasSuccess = true;
          this.back();
        }
      });
    },
    adicionarNovoDePara() {
      var depara = { deStr: "", paraStr: "" };
      this.deParaList.push(depara);
    },
    removerDePara(dePara) {
      var indexOf = this.deParaList.indexOf(dePara);
      this.deParaList.splice(indexOf, 1);
    },
    deChanged(dePara) {
      var paraDefault = this.categoriaList.filter(
        x => x.id == this.item.categoriaDeParaId && x.paraDefault != null
      );
      if (paraDefault.length > 0) {
        dePara.paraStr = paraDefault[0].paraDefault;
      }
    }
  },
  created() {
    this.getCategoriaSelectList();
    this.adicionarNovoDePara();
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="save">
      <b-form-group label="Categoria *" label-for="categoria" class="col-md-5">
        <Select2
          v-model="item.categoriaDeParaId"
          :options="categoriaSelectList"
          :settings="{ tags: true }"
        />
      </b-form-group>

      <div
        v-for="(dePara, index) in deParaList"
        v-bind:key="`dePara-${index}`"
        class="row pl-1"
      >
        <b-form-group
          v-bind:id="`input-group-${index}`"
          label="De"
          v-bind:label-for="`deStr${index}`"
          class="col-md-5"
        >
          <b-form-input
            v-bind:id="`deStr${index}`"
            v-model="dePara.deStr"
            v-on:blur="deChanged(dePara)"
            type="text"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          v-bind:id="`input-group-${index}`"
          label="Para"
          v-bind:label-for="`paraStr${index}`"
          class="col-md-5"
        >
          <b-form-input
            v-bind:id="`paraStr${index}`"
            v-model="dePara.paraStr"
            type="text"
            required
          ></b-form-input>
        </b-form-group>
        <div class="col-md-2" style="padding-left:0px;">
          <b-button
            class="btn"
            variant="link"
            size="sm"
            style="position:absolute;bottom:1.2rem;color:red;"
            v-if="index > 0"
            v-on:click="removerDePara(dePara)"
          >
            <i class="fa fa-times"></i>
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-button class="btn" variant="link" v-on:click="adicionarNovoDePara">
            <i class="fa fa-plus"></i> Adicionar
          </b-button>
        </div>
      </div>

      <b-form-group id="button-group" class="mt-4 text-right">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>
    </b-form>
  </div>
</template>
